import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Button, Card, Layout, Space, Typography, message, Spin } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Poll } from '../../../features/poll/components/Poll'
import { PollAnswerItem } from '../../../features/poll/types'
import { getAdminPollDefinition } from '../../../features/poll/api-admin'

const { Title, Text } = Typography

export default function QuizPreviewPage() {
  const { quizId } = useParams<{ quizId: string }>()
  const navigate = useNavigate()

  const [quiz, setQuiz] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (quizId) {
      loadQuiz(quizId)
    }
  }, [quizId])

  const loadQuiz = async (id: string) => {
    setLoading(true)
    try {
      const data = await getAdminPollDefinition(id)
      if (data) {
        setQuiz(data)
      } else {
        message.error('Опрос не найден')
        navigate('/admin/dealers/polls')
      }
    } catch (e: any) {
      message.error(e?.message || 'Не удалось загрузить опрос')
      navigate('/admin/dealers/polls')
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (answers: PollAnswerItem[]) => {
    setSubmitting(true)
    try {
      console.log('Ответы опроса:', answers)
      message.success('Опрос успешно пройден! (демо-режим)')

      // В демо-режиме просто показываем ответы в консоли
      setTimeout(() => {
        if (confirm('Опрос пройден! Посмотреть ответы в консоли и вернуться назад?')) {
          navigate('/admin/dealers/polls')
        }
      }, 500)
    } catch (e: any) {
      message.error(e?.message || 'Ошибка при отправке ответов')
    } finally {
      setSubmitting(false)
    }
  }

  const handleSave = (answers: PollAnswerItem[]) => {
    console.log('Сохранённые черновики ответов:', answers)
    message.info('Черновик сохранён (демо-режим)')
  }

  if (loading) {
    return (
      <Layout style={{ minHeight: '100vh', background: '#f0f2f5', padding: 20 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Spin size="large" />
        </div>
      </Layout>
    )
  }

  if (!quiz) {
    return (
      <Layout style={{ minHeight: '100vh', background: '#f0f2f5', padding: 20 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Text>Опрос не найден</Text>
        </div>
      </Layout>
    )
  }

  return (
    <>
      <Layout>
        <Space
          direction="vertical"
          size={24}
          style={{ width: '100%', maxWidth: 800, margin: '0 auto' }}
        >
          <Card>
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <Button
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate('/admin/dealers/polls')}
                >
                  Назад
                </Button>
                <Title level={2} style={{ margin: 0 }}>
                  Предпросмотр опроса
                </Title>
              </div>

              <Space direction="vertical" size={8}>
                <Text type="secondary">
                  Это демо-режим предпросмотра опроса. Ответы сохраняются только в консоли браузера.
                </Text>
                {quiz.steps && quiz.steps.length > 0 && (
                  <Text type="secondary">
                    Шагов: {quiz.steps.length} | Вопросов: {quiz.questions?.length || 0}
                  </Text>
                )}
              </Space>
            </Space>
          </Card>

          <Card>
            <Poll
              quiz={quiz}
              onSubmit={handleSubmit}
              onSave={handleSave}
              loading={submitting}
              submitText="Завершить демо"
              saveText="Сохранить черновик"
              showSaveButton={true}
            />
          </Card>

          <Card size="small">
            <Space direction="vertical" size={8}>
              <Text strong>Информация о демо-режиме:</Text>
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>Ответы выводятся в консоль браузера</li>
                <li>Данные не сохраняются в базе данных</li>
                <li>Можно проверить навигацию между шагами</li>
                <li>Валидация обязательных полей работает</li>
              </ul>
            </Space>
          </Card>
        </Space>
      </Layout>
    </>
  )
}
